export enum OnboardingScreenNames {
  MAIN = 'onboarding',
  ONBOARDING_FORM = 'onboarding_form',
}
